module.exports = __webpack_public_path__ + "static/mg-4b3c4155918241ee4e047e39c4d08a85.png";